export default {
  BusinessStockChange: {
    header: {
      spuCode: 'Product Code',
      spuName: 'Product Name',
      skuCode: 'SKU',
      categoryId: 'Product Category',
      warehouseCode: 'Warehouse Code',
      warehouseName: 'Warehouse Name',
      recordTypeMeaning: 'Business Type',
      warehouseType: 'Warehouse Type',
      changeTime: 'Inventory Change Time',
      recordCode: 'Related Documents'
    },

    table: {
      spuCode: 'Product Code',
      spuName: 'Product Name',
      skuCode: 'SKU',
      categoryName: 'Product Category',
      warehouseCode: 'Warehouse Code',
      warehouseName: 'Warehouse Name',
      recordTypeMeaning: 'Business Type',
      warehouseTypeMeaning: 'Warehouse Type',
      qtyTypeMeaning: 'Inventory Type',
      preRealNum: 'Inventory before the change',
      changeNum: 'Inventory Change Quantity',
      aftRealNum: 'Inventory after the change',
      recordCode: 'Ref. No.',
      operator: 'Operator',
      creationDate: 'Date Created'
    },

    voidBtn: 'Cancel',
    confirmText1: 'You are ',
    confirmText2: 'making a change to the inventory. Do you want to continue?',
  }
};
